<template>
  <div class="personal-center">
    <NoticeBar :visible="noticeVisible" :message="noticeMessage" :type="noticeType" :actions="noticeActions" @close="noticeVisible=false" />
    <!-- 主内容区域 -->
    <div class="center-content">
      <!-- 个人信息 -->
      <div v-if="currentSubNav === '个人信息' || currentSubNav === ''">
        <h4>个人信息</h4>
        <div class="info-section">
          <table class="info-table">
              <tbody>
                <tr>
                  <th>姓名</th>
                  <td>
                    <span v-if="!editingInfo.name">{{ userInfo.name }}</span>
                    <div v-else class="edit-field">
                      <input v-model="editForm.name" type="text" placeholder="请输入姓名">
                      <span v-if="errors.name" class="error-msg">{{ errors.name }}</span>
                    </div>
                    <span class="edit-icon" @click="startEditing('name')">✏</span>
                  </td>
                </tr>
                <tr>
                  <th>性别</th>
                  <td>
                    <span v-if="!editingInfo.gender">{{ userInfo.gender }}</span>
                    <div v-else class="edit-field">
                      <select v-model="editForm.gender">
                        <option value="男">男</option>
                        <option value="女">女</option>
                      </select>
                    </div>
                    <span class="edit-icon" @click="startEditing('gender')">✏</span>
                  </td>
                </tr>
                <tr>
                  <th>证件号码</th>
                  <td>{{ userInfo.idNumber }} <span class="hint-text">（不可修改）</span></td>
                </tr>
                <tr>
                  <th>证件地址</th>
                  <td>
                    <span v-if="!editingInfo.address">{{ userInfo.address }}</span>
                    <div v-else class="edit-field">
                      <input v-model="editForm.address" type="text" placeholder="请输入证件地址">
                      <span v-if="errors.address" class="error-msg">{{ errors.address }}</span>
                    </div>
                    <span class="edit-icon" @click="startEditing('address')">✏</span>
                  </td>
                </tr>
                <tr>
                  <th>手机</th>
                  <td>
                    <span v-if="!editingInfo.phone">{{ userInfo.phone }}</span>
                    <div v-else class="edit-field">
                      <input v-model="editForm.phone" type="text" placeholder="请输入手机号码">
                      <span v-if="errors.phone" class="error-msg">{{ errors.phone }}</span>
                    </div>
                    <span class="edit-icon" @click="startEditing('phone')">✏</span>
                  </td>
                </tr>
                <tr>
                  <th>电子邮箱</th>
                  <td>
                    <span v-if="!editingInfo.email">{{ userInfo.email }}</span>
                    <div v-else class="edit-field">
                      <input v-model="editForm.email" type="text" placeholder="请输入电子邮箱">
                      <span v-if="errors.email" class="error-msg">{{ errors.email }}</span>
                    </div>
                    <span class="edit-icon" @click="startEditing('email')">✏</span>
                  </td>
                </tr>
              </tbody>
            </table>
            
            <!-- 编辑操作按钮 -->
            <div v-if="isEditing" class="edit-actions">
              <button class="btn-submit" @click="saveChanges">保存</button>
              <button class="btn-cancel" @click="cancelEditing">取消</button>
            </div>
        </div>
      </div>

      <!-- 修改密码：与忘记密码逻辑一致（姓名+身份证校验后设置新密码） -->
      <div v-if="currentSubNav === '修改密码'">
        <h4>修改密码</h4>
        <div class="form-section">
          <table class="form-table">
            <tbody>
              <tr>
                <th>姓名</th>
                <td>
                  <input v-model="cp.name" type="text" placeholder="请输入姓名">
                </td>
              </tr>
              <tr>
                <th>身份证号</th>
                <td>
                  <input v-model="cp.idCard" type="text" placeholder="请输入18位身份证号">
                </td>
              </tr>
              <tr>
                <th>校验</th>
                <td>
                  <button class="btn-submit" @click="verifyByIdCard" :disabled="cp.loading">{{ cp.loading ? '校验中...' : '校验信息' }}</button>
                  <span class="hint-text" v-if="cp.message">{{ cp.message }}</span>
                </td>
              </tr>
              <tr v-if="cp.validated">
                <th>新密码</th>
                <td>
                  <input v-model="cp.newPassword" type="password" placeholder="请输入新密码">
                </td>
              </tr>
              <tr v-if="cp.validated">
                <th>确认密码</th>
                <td>
                  <input v-model="cp.confirmPassword" type="password" placeholder="再次输入新密码">
                </td>
              </tr>
            </tbody>
          </table>
          <div class="form-actions" v-if="cp.validated">
            <button class="btn-submit" @click="resetByIdCard" :disabled="cp.loading">{{ cp.loading ? '保存中...' : '确认重置' }}</button>
          </div>
          <div v-if="cp.resetMessage" class="msg">{{ cp.resetMessage }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProfile, updateProfile, logout as authLogout } from '../api/auth';
import { api } from '../utils/api';
import { clearTokens, clearUser } from '../api/storage';
import NoticeBar from './NoticeBar.vue';
export default {
  name: 'PersonalCenter',
  components: { NoticeBar },
  props: {
    currentSubNav: String
  },
  data() {
    return {
      // 用户信息
      userInfo: {
        name: '-',
        gender: '-',
        idNumber: '-',
        address: '-',
        phone: '-',
        email: '-'
      },
      // 编辑表单数据
      editForm: {},
      // 正在编辑的字段
      editingInfo: {
        name: false,
        gender: false,
        address: false,
        phone: false,
        email: false
      },
      // 修改密码流程的本地状态（与忘记密码一致）
      cp: {
        name: '',
        idCard: '',
        loading: false,
        message: '',
        validated: false,
        newPassword: '',
        confirmPassword: '',
        resetMessage: ''
      },
      // 表单验证错误
      errors: {},
      noticeVisible: false,
      noticeMessage: '',
      noticeType: 'info',
      noticeActions: []
    }
  },
  computed: {
    // 是否处于编辑状态
    isEditing() {
      return Object.values(this.editingInfo).some(value => value);
    }
  },
  watch: {
    // 不在子组件中主动触发退出，改由父组件统一处理
  },
  methods: {
    // 开始编辑字段
    startEditing(field) {
      // 重置错误信息
      this.errors = {};
      // 设置编辑状态
      this.editingInfo[field] = true;
      // 复制当前值到编辑表单
      this.editForm[field] = this.userInfo[field];
    },
    
    // 取消编辑
    cancelEditing() {
      // 重置所有编辑状态
      for (const field in this.editingInfo) {
        this.editingInfo[field] = false;
      }
      // 清空错误信息
      this.errors = {};
    },
    
    // 保存修改
    async saveChanges() {
      // 验证表单
      if (!this.validateForm()) {
        return;
      }
      
      // 组装允许更新到后端的字段
      const payload = {};
      if (this.editingInfo.email) payload.email = this.editForm.email;
      if (this.editingInfo.phone) payload.phone = this.editForm.phone;
      if (this.editingInfo.name) payload.username = this.editForm.name;
      if (this.editingInfo.gender) payload.gender = this.editForm.gender;
      if (this.editingInfo.address) payload.address = this.editForm.address;
      try {
        if (Object.keys(payload).length) {
          const updated = await updateProfile(payload);
          // 将后端返回映射到展示字段
          if (updated) {
            this.userInfo.email = updated.email ?? this.userInfo.email;
            this.userInfo.phone = updated.phone ?? this.userInfo.phone;
            this.userInfo.name = (updated.username ?? this.userInfo.name);
            this.userInfo.idNumber = (updated.id_card ?? this.userInfo.idNumber);
            this.userInfo.gender = (updated.gender ?? this.userInfo.gender);
            this.userInfo.address = (updated.address ?? this.userInfo.address);
          }
        }
        // 关闭所有编辑态
        for (const field in this.editingInfo) {
          this.editingInfo[field] = false;
        }
        this.noticeMessage = '个人信息更新成功！'
        this.noticeType = 'success'
        this.noticeActions = []
        this.noticeVisible = true
        setTimeout(() => { this.noticeVisible = false }, 2500)
        localStorage.setItem('userInfo', JSON.stringify(this.userInfo));
      } catch (e) {
        const status = e?.response?.status;
        const data = e?.response?.data;
        console.error('更新个人信息失败', status, data, e);
        if (status === 401) {
          this.noticeMessage = '登录已过期或未授权，请重新登录后再试'
          this.noticeType = 'error'
          this.noticeActions = []
          this.noticeVisible = true
          setTimeout(() => { this.noticeVisible = false }, 2500)
          return;
        }
        if (status === 400) {
          // 简化展示后端校验错误
          const msgs = [];
          const push = (k) => {
            const v = data?.[k];
            if (Array.isArray(v) && v.length) msgs.push(`${k}: ${v[0]}`);
            else if (typeof v === 'string') msgs.push(`${k}: ${v}`);
          };
          ['username','email','phone','gender','address','non_field_errors'].forEach(push);
          this.noticeMessage = msgs.length ? msgs.join('\n') : '输入有误，请检查后再试'
          this.noticeType = 'error'
          this.noticeActions = []
          this.noticeVisible = true
          setTimeout(() => { this.noticeVisible = false }, 2500)
        } else if (status >= 500) {
          this.noticeMessage = '服务器错误，请稍后重试'
          this.noticeType = 'error'
          this.noticeActions = []
          this.noticeVisible = true
          setTimeout(() => { this.noticeVisible = false }, 2500)
        } else {
          this.noticeMessage = '更新失败，请稍后重试'
          this.noticeType = 'error'
          this.noticeActions = []
          this.noticeVisible = true
          setTimeout(() => { this.noticeVisible = false }, 2500)
        }
      }
      
      // 清空错误信息
      this.errors = {};
    },
    
    // 验证表单
    validateForm() {
      // 清除之前的错误
      this.errors = {}
      let isValid = true;
      
      // 验证姓名
      if (this.editingInfo.name) {
        if (!this.editForm.name || this.editForm.name.trim() === '') {
          this.errors.name = '姓名不能为空';
          isValid = false;
        }
      }
      
      // 验证手机号
      if (this.editingInfo.phone) {
        const phoneRegex = /^1[3456789]\d{9}$/;
        if (!this.editForm.phone) {
          this.errors.phone = '手机号不能为空';
          isValid = false;
        } else if (!phoneRegex.test(this.editForm.phone)) {
          this.errors.phone = '请输入正确的手机号';
          isValid = false;
        }
      }
      
      // 验证邮箱
      if (this.editingInfo.email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!this.editForm.email) {
          this.errors.email = '邮箱不能为空';
          isValid = false;
        } else if (!emailRegex.test(this.editForm.email)) {
          this.errors.email = '请输入正确的邮箱地址';
          isValid = false;
        }
      }
      
      // 验证地址
      if (this.editingInfo.address) {
        if (!this.editForm.address || this.editForm.address.trim() === '') {
          this.errors.address = '地址不能为空';
          isValid = false;
        }
      }
      
      return isValid;
    },
    
    // 处理退出登录
    handleLogout() {
      this.noticeMessage = '确定要退出登录吗？'
      this.noticeType = 'warning'
      this.noticeActions = [
        { label: '取消', onClick: () => { this.noticeVisible = false } },
        { label: '确定', primary: true, onClick: () => {
          this.noticeVisible = false
          authLogout().catch(() => {})
          clearTokens()
          clearUser()
          window.location.hash = 'login'
          setTimeout(() => window.location.reload(), 100)
        } }
      ]
      this.noticeVisible = true
    },
    // 修改密码：与忘记密码相同流程
    async verifyByIdCard() {
      this.cp.loading = true; this.cp.message = '';
      try {
        if (!this.cp.name || !this.cp.idCard) { this.cp.message = '请填写姓名与身份证号'; return; }
        const res = await api.postJson('/api/user/password/reset/verify-idcard/', { name: this.cp.name, id_card: this.cp.idCard });
        this.cp.validated = true;
        this.cp.message = res.message || '验证通过，请设置新密码';
      } catch (e) {
        this.cp.message = e.message || '验证失败，请检查姓名与身份证号';
      } finally { this.cp.loading = false; }
    },
    async resetByIdCard() {
      this.cp.loading = true; this.cp.resetMessage = '';
      try {
        if (!this.cp.validated) { this.cp.resetMessage = '请先完成校验'; return; }
        if (!this.cp.newPassword || !this.cp.confirmPassword) { this.cp.resetMessage = '请填写新密码'; return; }
        if (this.cp.newPassword !== this.cp.confirmPassword) { this.cp.resetMessage = '两次输入的新密码不一致'; return; }
        const res = await api.postJson('/api/user/password/reset/by-idcard/', { name: this.cp.name, id_card: this.cp.idCard, new_password: this.cp.newPassword });
        this.cp.resetMessage = res.message || '密码重置成功';
        // 完成后清除登录态，返回登录页重新登录
        try { clearTokens(); clearUser(); } catch (e) {}
        setTimeout(() => { window.location.hash = 'login'; }, 800);
      } catch (e) {
        this.cp.resetMessage = e.message || '重置失败，请检查姓名与身份证号';
      } finally { this.cp.loading = false; }
    }
  },
  
  // 组件挂载时从后端加载当前账号信息，并回填到展示
  mounted() {
    // 先读取本地缓存兜底展示
    try {
      const saved = localStorage.getItem('userInfo');
      if (saved) {
        try {
          const parsed = JSON.parse(saved);
          if (parsed && typeof parsed === 'object') {
            this.userInfo = { ...this.userInfo, ...parsed };
          }
        } catch (e) {
          console.warn('解析本地用户信息失败', e);
        }
      }
    } catch (e) {
      console.warn('读取本地用户信息失败', e);
    }
    // 再请求后端最新数据
    getProfile()
      .then(data => {
        if (!data) return;
        this.userInfo = {
          name: data.username || this.userInfo.name,
          gender: data.gender || this.userInfo.gender,
          idNumber: data.id_card || '-',
          address: data.address || this.userInfo.address,
          phone: data.phone || '-',
          email: data.email || '-',
        };
        localStorage.setItem('userInfo', JSON.stringify(this.userInfo));
      })
      .catch(err => {
        console.warn('获取个人信息失败：', err?.response?.status, err?.response?.data);
      });
  }
}
</script>

<style scoped>
.personal-center {
  width: 100%;
}
.center-content {
  flex: 1;
  background-color: white;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.center-content h4 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 16px;
  font-weight: bold;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
}

.info-section,
.form-section,
.instruction-section {
  padding: 10px 0;
}

.instruction-section {
  line-height: 1.8;
}

.instruction-section p {
  margin-bottom: 15px;
  color: #333;
}

.instruction-section ol {
  padding-left: 20px;
  margin-bottom: 15px;
}

.instruction-section li {
  margin-bottom: 10px;
  color: #666;
}

.info-table,
.form-table {
  width: 100%;
  border-collapse: collapse;
}

.info-table th,
.info-table td,
.form-table th,
.form-table td {
  padding: 12px;
  border: 1px solid #e0e0e0;
  text-align: left;
}

.edit-icon {
  color: #0066cc;
  cursor: pointer;
  margin-left: 10px;
  font-size: 14px;
  transition: color 0.3s;
}

.edit-icon:hover {
  color: #0052a3;
}

.hint-text {
  color: #999;
  font-size: 12px;
  margin-left: 5px;
}

.edit-field {
  position: relative;
  display: flex;
  flex-direction: column;
}

.edit-field input,
.edit-field select {
  width: 300px;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.error-msg {
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 5px;
}

.edit-actions {
  margin-top: 20px;
  display: flex;
  gap: 15px;
  justify-content: flex-end;
}

.info-table th,
.form-table th {
  background-color: #f5f9ff;
  color: #0066cc;
  font-weight: bold;
  width: 120px;
}

.form-table input[type="text"],
.form-table input[type="password"] {
  width: 300px;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.form-table td {
  display: flex;
  align-items: center;
  gap: 10px;
}

.btn-send-code {
  background-color: #0066cc;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.btn-send-code:hover {
  background-color: #0052a3;
}

.form-actions {
  margin-top: 20px;
  display: flex;
  gap: 15px;
  justify-content: flex-end;
}

.btn-cancel {
  background-color: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;
  padding: 8px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}

.btn-cancel:hover {
  background-color: #e5e5e5;
}

.btn-submit {
  background-color: #0066cc;
  color: white;
  border: none;
  padding: 8px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.btn-submit:hover {
  background-color: #0052a3;
}
</style>
